import { render } from "./NewAux.vue?vue&type=template&id=79ca3064"
import script from "./NewAux.vue?vue&type=script&lang=js"
export * from "./NewAux.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__